import 'isomorphic-unfetch'
import { parseCookies, setCookie } from 'nookies';
import uuidv4 from 'uuid/v4';

import config from '../../config';
import actionTypes from "./types";

export async function loadBaseData(ctx) {
  const cookies = parseCookies(ctx);
  const headers = {};

  if (cookies.token) {
    headers['X-Auth-Token'] = cookies.token;
  }

  const data = await (await fetch(`${config.apiURL}/base_data.php`, { headers })).json();
  
  if (data.token) {
    setCookie(ctx, 'token', data.token, {
      maxAge: 30 * 24 * 60 * 60,
      path: '/',
    })
  }

  return dispatch => {
    dispatch({
      type: actionTypes.LOAD_DATA,
      data
    });
  }
}

export const addToCart = (productId, quantity, callback) => (dispatch, getStore) => {
  fetch(`${config.apiURL}/cart.php?add[${parseInt(productId)}]=${parseInt(quantity)}`, {
    headers: {
      'X-Auth-Token': getStore().token
    }
  })
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: actionTypes.UPDATE_CART,
        cart: data,
      });

      callback && callback();
    })
}

export const setCartQuantity = (productId, quantity, callback) => (dispatch, getStore) => {
  fetch(`${config.apiURL}/cart.php?set[${parseInt(productId)}]=${parseInt(quantity)}`, {
    headers: {
      'X-Auth-Token': getStore().token
    }
  })
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: actionTypes.UPDATE_CART,
        cart: data,
      });

      callback && callback();
    })
}